<div class="card shadow-sm rounded-lg flex flex-col h-full">
  <div class="card-header border-bottom py-3 px-6 font-mediumrounded-t-lg">
    Personal Accounts
  </div>
  <div class="card-body p-6 flex-grow overflow-auto">
    <kendo-grid
      [kendoGridBinding]="repState.repPersonalAccounts"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
      (remove)="removeHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button gdAdminOnly
          type="button"
          kendoGridAddCommand
          kendoButton
          [icon]="'plus'"
          [themeColor]="'primary'"
          class="mr-2"
        >
          Add New Record
        </button>
        <button gdAdminOnly
          type="button"
          kendoButton
          [icon]="'refresh'"
          class="ml-auto"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column field="custodian" title="Custodian" width="100">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="accountNumber"
        title="Account Number"
        width="150"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="accountTitle" title="Title" width="100">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="relationship" title="Relationship" width="150">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="startDate" title="Start Date" width="100">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.startDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="w-full"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="endDate" title="End Date" width="100">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.endDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="w-full"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="175" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoButton [themeColor]="'primary'" kendoGridEditCommand class="mr-2" gdAdminOnly>
            <span class="k-icon k-i-edit"></span>
            Edit
          </button>
          <button kendoButton [themeColor]="'error'" kendoGridRemoveCommand *ngIf="dataItem.active" class="mr-2" gdAdminOnly>
            <span class="k-icon k-i-delete"></span>
            Remove
          </button>
          <button kendoButton [themeColor]="'success'" kendoGridSaveCommand [disabled]="formGroup?.invalid" class="mr-2" gdAdminOnly>
            <span class="k-icon k-i-save"></span>
            Save
          </button>
          <button kendoButton kendoGridCancelCommand>
            <span class="k-icon k-i-cancel"></span>
            Cancel
          </button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
